<template>
  <profile-edit-section-card
    v-if="localState"
    title="Rate"
    breadcrumb-label="Profile"
    :saving="isSaving"
    :has-unsaved-changes="hasUnsavedChanges"
    @breadcrumb-click="cancelEdit"
    @save="handleSave"
    @cancel="cancelEdit"
  >
    <fieldset class="mb-24">
      <legend class="form__label pb-8">Average hourly rate</legend>
      <p class="text-caption mb-16">You can update your rate at anytime</p>
      <div class="inline-flex items-center gap-16">
        <poppins-text-field
          id="min-rate"
          v-model="localState.paymentRateMin"
          label-name="$ Min"
          type="text"
          pattern="[0-9]*"
          maxlength="3"
          inputmode="numeric"
          :limit-input-to-pattern="true"
        />
        <span>to</span>
        <poppins-text-field
          id="max-rate"
          v-model="localState.paymentRateMax"
          label-name="$ Max"
          type="text"
          pattern="[0-9]*"
          maxlength="3"
          inputmode="numeric"
          :limit-input-to-pattern="true"
        />
      </div>
    </fieldset>
    <poppins-dropdown
      id="distance-willing-to-travel"
      v-model="localState.distanceWillingToTravel"
      label-name="How many miles from home are you willing to work?"
      :options="distanceOptions"
    />
  </profile-edit-section-card>
</template>

<script lang="ts">
import PoppinsTextField from '@/components/textfield/TextField.vue';
import PoppinsDropdown from '@/components/dropdown/Dropdown.vue';
import ProfileEditSectionCard from '../../components/ProfileEditSectionCard.vue';
import profileEditMixin from '../../mixins/profileEditMixin';
import { distanceOptions } from '../../__types__/CareTypeFormOptions';
import type { HousekeepingProfileFormState } from '../../__types__/HousekeepingProfileTypes';

export default {
  name: 'HousekeepingRateForm',
  components: {
    ProfileEditSectionCard,
    PoppinsTextField,
    PoppinsDropdown,
  },
  mixins: [profileEditMixin],
  data(): any {
    return {
      localState: null,
      originalState: null,
    };
  },
  computed: {
    distanceOptions: () => distanceOptions(),
    hasUnsavedChanges(): boolean {
      if (!this.localState || !this.originalState) return false;
      return JSON.stringify(this.localState) !== JSON.stringify(this.originalState);
    },
  },
  watch: {
    $route() {
      this.initializeFormState();
    },
    formState: {
      handler(newState) {
        if (newState) {
          this.initializeFormState();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.initializeFormState();
  },
  methods: {
    initializeFormState() {
      const state = this.formState as HousekeepingProfileFormState | null;
      if (!state) return;

      this.localState = {
        paymentRateMin: String(state.paymentRateMin || 15),
        paymentRateMax: String(state.paymentRateMax || 25),
        distanceWillingToTravel: String(state.distanceWillingToTravel || 10),
      };
      this.originalState = JSON.parse(JSON.stringify(this.localState));
    },
    async handleSave() {
      if (!this.localState) return;

      if (this.hasUnsavedChanges) {
        await this.saveSection({
          paymentRate: {
            min: Number(this.localState.paymentRateMin) * 100,
            max: Number(this.localState.paymentRateMax) * 100,
          },
          distanceWillingToTravel: Number(this.localState.distanceWillingToTravel),
        });
      }
    },
  },
};
</script>
